<template>

  <div class="widget-content-ticker"
       v-if="hasSource"
       :style="{ '--dmb-ticker-animation-duration': animationDuration + 's' }">
    <div class="track" :class="{ freeze }">
      <dmb-widget-styled-text v-if="widget.settings" :style="widget.settings.textStyle">{{
          content
        }}
      </dmb-widget-styled-text>
      <dmb-widget-styled-text v-if="widget.settings" :style="widget.settings.textStyle">{{
          content
        }}
      </dmb-widget-styled-text>
    </div>
  </div>

  <div class="widget-content-placeholder" v-else>{{ $t('app.widgets.widgetContentTicker.noTickerData') }}</div>

</template>

<script>

import {Options, Vue} from 'vue-class-component'

import WidgetStyledText from "../WidgetStyledText.vue";

import TickerSource from '../../enum/TickerSource';
import tickerSourceUrlFilter from '../../filter/tickerSourceUrl';
import {TickerStoreAction} from '../../store/ticker';

const MAX_TICKER_SPEED = 40;

export default Options({
  name: 'dmb-widget-content-ticker',
  components: {
    [WidgetStyledText.name]: WidgetStyledText
  },
  props: {
    widget: Object,
    freeze: Boolean
  }
})(
    class WidgetContentTicker extends Vue {
      created() {
      }

      get animationDuration() {
        if (!this.content || !this.widget.settings.animationSpeed) {
          return 10;
        }
        const baseDuration = 10; // 100% higher number is slower and lower number is faster
        return baseDuration * (100 / this.widget.settings.animationSpeed);
      }

      async loadFeedContent(source) {
        const sourceUrl = tickerSourceUrlFilter(source);
        if (!sourceUrl) {
          return;
        }

        try {
          const content = await this.$store.dispatch(TickerStoreAction.LOAD_FEED, {
            id: source, url: sourceUrl
          });

          const titles = content.map(item => item.title);
          this.content = titles.join(' - ');
        } catch (e) {

          this.logger.error('Error loading ticker content', e);
        }
      }

      get content() {

        const settings = this.widget.settings;
        const source = settings.source;

        if (source === TickerSource.CUSTOM_TEXT) {

          return settings.content;
        } else {

          const feedItems = this.$store.state.ticker.feeds[source];

          if (!feedItems) {
            return null;
          }

          const titles = feedItems.map(item => item.title);
          return titles.join(' - ');
        }
      }

      get hasSource() {

        return this.widget.settings.source;
      }


    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentTicker.scss" lang="scss"></style>
